"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var logging_1 = require("@nerdwallet/logging");
var logger = (0, logging_1.getLogger)("sessionStorage");
/**
 * `useSessionStorage` is an interface for window.sessionStorage.
 */
var useSessionStorage = function () {
    var getItem = (0, react_1.useCallback)(function (key) {
        if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.sessionStorage)) {
            return window.sessionStorage.getItem("".concat(key));
        }
        return null;
    }, []);
    var removeItem = (0, react_1.useCallback)(function (key) {
        if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.sessionStorage)) {
            window.sessionStorage.removeItem("".concat(key));
        }
    }, []);
    var setItem = (0, react_1.useCallback)(function (key, value) {
        try {
            if (typeof window !== "undefined" && (window === null || window === void 0 ? void 0 : window.sessionStorage)) {
                window.sessionStorage.setItem("".concat(key), value);
            }
        }
        catch (e) {
            // This generally means that the storage is full.
            logger.error(e);
        }
    }, []);
    var sessionStorage = (0, react_1.useMemo)(function () { return ({
        getItem: getItem,
        removeItem: removeItem,
        setItem: setItem,
    }); }, [getItem, removeItem, setItem]);
    return sessionStorage;
};
exports.default = useSessionStorage;
